import React from 'react';
import classNames from 'clsx';

import { NumberInput } from 'ui-components/components/number-input';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {number} [props.quantity]
 * @param {(value: number) => void} props.onChange
 * @param {boolean} [props.slimInput]
 * @returns {JSX.Element}
 */

export const QuantityInput = ({ quantity = 0, onChange, slimInput = true }) => {
  return (
    <div className={style['input-wrapper']}>
      <Text textType={TextType.Label} value={messages.addToLocationLocationQuantity} />
      <div className={classNames({ [style['slim-input']]: slimInput })}>
        <NumberInput
          className={style['number-input']}
          data-ignore-root-focus='true'
          min={0}
          onChange={onChange}
          testId='quantity-input'
          value={quantity}
        />
      </div>
    </div>
  );
};
